/* Moteur de prix MonSacPoubelle :
   1) bascule TOUS les prix affichés TTC ↔ HT selon le mode Particulier/Pro
      (window.MSP / événement msp:mode-change) — suffixe « HT » en mode pro ;
   2) affiche le prix au sac (« 0,28 €/sac ») sur les cartes et la fiche produit,
      recalculé dans le mode courant. Le checkout reste TTC (affichage informatif). */
(function () {
  'use strict';

  var TVA = 1.2;
  var SEL = '.price-item--regular, .price-item--sale, .price-item--last, .totals__total-value, .cart-item__price-wrapper .price--end:not(.cart-item__old-price)';
  var PRICE_RE = /(\d+(?:\s?\d{3})*[.,]\d{2})/;

  function fmt(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function priceTextNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (PRICE_RE.test(n.nodeValue)) return n;
    }
    return null;
  }

  function bagCount(el) {
    var scope = el.closest('.cart-item');
    var title = scope && scope.querySelector('.cart-item__name');
    if (title) {
      /* Dans le panier, le prix affiché est le total de ligne :
         sacs = sacs du carton × quantité de cartons. */
      var m0 = title.textContent.match(/(\d+)\s*sacs?\b/i);
      if (!m0) return '';
      var qtyInput = scope.querySelector('.quantity__input, input[name^="updates"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      return String(parseInt(m0[1], 10) * qty);
    }
    if (!title) {
      scope = el.closest('.card-wrapper');
      title = scope && scope.querySelector('.card__heading');
    }
    if (!title) {
      scope = el.closest('.product__info-wrapper, .product__info-container, section');
      title = scope && scope.querySelector('.product__title');
    }
    var m = title && title.textContent.match(/(\d+)\s*sacs?\b/i);
    return m ? m[1] : '';
  }

  function annotate(el) {
    if (el.dataset.mspCents) return;
    var node = priceTextNode(el);
    if (!node) return;
    var m = node.nodeValue.match(PRICE_RE);
    if (!m) return;
    var cents = Math.round(parseFloat(m[1].replace(/\s/g, '').replace(',', '.')) * 100);
    if (!cents) return;
    el.dataset.mspCents = String(cents);
    el.dataset.mspCount = bagCount(el);
  }

  function paint() {
    var pro = !!(window.MSP && window.MSP.getMode() === 'pro');
    document.querySelectorAll(SEL).forEach(function (el) {
      annotate(el);
      var ttc = parseInt(el.dataset.mspCents, 10);
      if (!ttc) return;
      var cents = pro ? Math.round(ttc / TVA) : ttc;

      var node = priceTextNode(el);
      if (node) node.nodeValue = node.nodeValue.replace(PRICE_RE, fmt(cents));

      var tax = el.querySelector('.msp-tax');
      if (pro) {
        if (!tax) {
          tax = document.createElement('span');
          tax.className = 'msp-tax';
          el.appendChild(tax);
        }
        tax.textContent = ' HT';
      } else if (tax) {
        tax.remove();
      }

      var count = parseInt(el.dataset.mspCount, 10);
      if (count) {
        var per = el.querySelector('.msp-per-bag');
        if (!per) {
          per = document.createElement('span');
          per.className = 'msp-per-bag';
          el.appendChild(per);
        }
        per.textContent = fmt(cents / count) + ' €/sac';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
  window.addEventListener('msp:mode-change', paint);
  document.addEventListener('shopify:section:load', paint);

  /* Le panier (drawer et page) se re-rend en HTML frais à chaque modification :
     on repeint après chaque mutation, avec un garde anti-boucle. */
  var painting = false;
  var pending = null;
  var origPaint = paint;
  paint = function () {
    painting = true;
    origPaint();
    requestAnimationFrame(function () { painting = false; });
  };
  function watchCart() {
    ['cart-drawer', 'cart-items', 'cart-drawer-items', '#ProductGridContainer'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        new MutationObserver(function () {
          if (painting) return;
          clearTimeout(pending);
          pending = setTimeout(paint, 120);
        }).observe(el, { childList: true, subtree: true });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }
})();
